import { Controller } from "@hotwired/stimulus"

export default class DragDropController extends Controller {
  static classes = ["dropZoneActive"]
  static targets = ["dragImage"]
  static values = {
    reorderable: { type: Boolean, default: true },
  }

  dragStart(event) {
    this.currentDraggedElement = event.target
    this.#setDragImage(event)
    event.dataTransfer.setData("data", JSON.stringify(event.params))
  }

  drop(event) {
    if (this.currentDraggedElement) {
      this.#toggleDropZoneActiveClasses(event.currentTarget, false)

      const allDraggableElements = Array.from(
        document.querySelectorAll('div[draggable="true"]')
      )

      if (this.reorderableValue) {
        this.#reinsertDraggedElement(allDraggableElements, event.currentTarget)
      }

      const dataWrapper = JSON.parse(event.dataTransfer.getData("data"))
      const dropEvent = new CustomEvent("drag-drop:item-dropped", {
        detail: { value: dataWrapper.data },
        bubbles: true,
      })
      event.currentTarget.dispatchEvent(dropEvent)
    }
  }

  dragEnter(event) {
    if (this.currentDraggedElement) {
      this.#toggleDropZoneActiveClasses(event.currentTarget, true)
    }
  }

  dragLeave(event) {
    if (this.currentDraggedElement) {
      this.#toggleDropZoneActiveClasses(event.currentTarget, false)
    }
  }

  dragEnd(event) {
    if (this.currentDraggedElement) {
      this.#toggleDropZoneActiveClasses(event.currentTarget, false)
    }
    this.currentDraggedElement = null
  }

  #setDragImage(event) {
    const dragImage =
      this.dragImageTargets.find((imageTarget) =>
        event.currentTarget.contains(imageTarget)
      ) || event.currentTarget
    event.dataTransfer.setDragImage(dragImage, 0, 0)
  }

  #toggleDropZoneActiveClasses(element, force) {
    this.dropZoneActiveClasses.forEach((className) =>
      element.classList.toggle(className, force)
    )
  }

  #reinsertDraggedElement(elementsArray, dropZone) {
    const draggedIndex = elementsArray.indexOf(this.currentDraggedElement)
    const targetIndex = elementsArray.indexOf(dropZone)

    draggedIndex > targetIndex
      ? dropZone.before(this.currentDraggedElement)
      : dropZone.after(this.currentDraggedElement)
  }
}
